import _get from 'lodash/get';
import { Pixall, Google } from '../../analytics/index.js';
import { addListingTriggerData, isPremiumSpotlight, transformTileType, isVDP } from '../../utilities/index.js';
import { getPageId } from '../../transformers/pixall/DataLayerTransformer.js';
import { getVehicleCommonDataLayer } from '../../transformers/pixall/inventoryTransformer.js';
import googleInventoryTransformer from '../../transformers/google/inventoryTransformer.js';
import { valueEventCode } from '../../constants/index.js';
function productTileClickHelper(_ref, option) {
  let {
    data = {},
    dataLayer = {},
    pixallData = {},
    event
  } = _ref;
  const {
    inventory,
    isShoppingAssistantCtaClick = false,
    pageType,
    par = 'v_lstg',
    vendor,
    paginatedListingIndex
  } = data;
  let cdl = {};
  let cmp = 'ec_pa_txt';
  if (event.target.tagName?.toLowerCase() === 'img') {
    cmp = 'ec_pa_lgo';
  }

  // filter out certified tiles, for backwards capatibility check from data, productTiles.epn & productTiles.tileType
  const productTiles = _get(inventory, 'productTiles', []).filter(tile => tile && tile.tileType !== 'CERTIFIED_CAR');
  const epn = data.epn || _get(inventory, 'productTiles[0].epn', '') || transformTileType({
    tileType: _get(productTiles, '[0]tileType', '') || data.tileType,
    isPrivateSeller: _get(inventory, 'owner.privateSeller', false)
  });
  const zip = _get(dataLayer, 'user.zipCode', '');
  const pageId = getPageId(dataLayer);
  const isSiriusXM = epn === 'sirius_xm';
  const eventSource = isSiriusXM ? 'promotion' : 'vehicle-history-report';
  const pageName = _get(dataLayer, 'page.pageName', '');
  const inheritPageData = !['vdp'].includes(pageName);
  const isAutoCheck = epn.includes('autocheck');
  const {
    AUTOCHECK
  } = valueEventCode;
  const listingType = isPremiumSpotlight(par) ? 'highlight' : undefined;
  if (isAutoCheck) {
    cdl.eventProperties = {
      event: {
        valueEventCode: AUTOCHECK
      }
    };
  }
  if (pageName === 'ddp' || pageName === 'dlrinfoinvovrnew') {
    cdl.eventProperties = {
      ...cdl.eventProperties,
      vehicle: getVehicleCommonDataLayer(inventory)
    };
  }
  cdl = addListingTriggerData(par, cdl);
  const payload = {
    cmp,
    epn,
    par,
    zip,
    cdl,
    listingType
  };
  const labelSuffix = isShoppingAssistantCtaClick ? '-shopasst' : '';
  const label = (epn ? `${cmp}-${epn}-${pageId}` : `${cmp}-${pageId}`) + labelSuffix;
  Pixall.sendClickEvent({
    pixallData: {
      ...pixallData,
      clickTypeToListingType: isVDP(dataLayer)
    },
    listingType,
    eventSource,
    eventType: 'open',
    goal: eventSource,
    label,
    pageType,
    par,
    vendor: epn || vendor,
    ...pixallData,
    cdl
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'partner',
    eventResult: `${isSiriusXM ? 'vendor::siriusxm' : `${eventSource}::${epn}`}`,
    eventData: !isSiriusXM && inventory?.owner.id ? {
      vehicle: {
        ...googleInventoryTransformer(inventory, {
          target: 'vehicle',
          dataLayer
        }, inheritPageData),
        listingPosition: paginatedListingIndex
      }
    } : {}
  }, option);
  return payload;
}
export default productTileClickHelper;